// extracted by mini-css-extract-plugin
export default {"summary":"Payout_summary__D6Hyv"};